export const colors = [
  '#1a7bbb',
  '#538dc4',
  '#77a0cd',
  '#98b4d6',
  '#b6c8df',
  '#d3dce8',
  '#e3e9d8',
  '#d5e2bf',
  '#c7dba7',
  '#b9d48e',
  '#aacc76',
  '#9ac55d',
];

export const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
